import { Type } from 'class-transformer';
import { CorpAPWorkQueueItemResultDto } from '../../cirabooks/corporate-cirabooks-module/_models/accounts-payable/work-management-queue/corp-ap-work-queue-item-result-dto';

export class CorpAPWorkQueueDetailResultDto {
    allowApprove: boolean;
    allowDeny: boolean;

    @Type(() => CorpAPWorkQueueItemResultDto)
    workQueue: CorpAPWorkQueueItemResultDto;
}
